import { log } from '@atlassian/mpac-utils';
import React from 'react';
import FeedbackDetailsReportExpand from './FeedbackDetailsReportExpand';
import LicenseReportExpand from './LicenseReportExpand';
import TransactionReportExpand from './TransactionReportExpand';
export default function ReportDetailsExpand(props) {
  const {
    report,
    reportDetails
  } = props;
  const renderSwitch = param => {
    switch (param) {
      case 'transaction':
        return /*#__PURE__*/React.createElement(TransactionReportExpand, {
          reportDetails: reportDetails
        });
      case 'license':
        return /*#__PURE__*/React.createElement(LicenseReportExpand, {
          reportDetails: reportDetails
        });
      case 'feedback':
        return /*#__PURE__*/React.createElement(FeedbackDetailsReportExpand, {
          reportDetails: reportDetails
        });
      default:
        log.error("ReportDetailsExpand", "report type not available");
    }
  };
  return /*#__PURE__*/React.createElement("div", null, renderSwitch(report));
}